module.exports = __webpack_public_path__ + "8a2ea26aa66d7254cdbec525e5eb5598.svg";